export default {
  // Navbar
  "nav.home": "Início",
  "nav.shoppingGuide": "Guia de Compras",
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.categories": "Categorias",
  "nav.guides": "Guias",
  "nav.qc": "QC",
  "nav.shipping": "Envio",
  "nav.comparisons": "Comparações",
  "nav.safety": "Segurança",
  "nav.language": "Idioma",
  "nav.search": "Pesquisar",
  "nav.cta": "Explorar Spreadsheet",

  // Hero
  "hero.eyebrow": "GUIA CSSBUY • SPREADSHEET • COMPRAS",
  "hero.h1": "CSSBuy Spreadsheet: encontre produtos, vendedores e guias de compra",
  "hero.description": "Explore o CSSBuy Spreadsheet, descubra produtos e vendedores, compare opções e aprenda como avaliar QC, armazenamento, envio e informações importantes antes de realizar uma compra.",
  "hero.cta.primary": "Explorar CSSBuy Spreadsheet",
  "hero.cta.secondary": "Ver Guias de Compra",
  "hero.trust": "Conteúdo informativo • Guias atualizados • Comparações transparentes",

  // Search
  "search.h2": "Encontre rapidamente no CSSBuy Spreadsheet",
  "search.placeholder": "Pesquise produtos, categorias ou vendedores...",
  "search.filters": "Categoria / Produto / Vendedor / QC / Popularidade / Mais recentes",
  "search.button": "Pesquisar",

  // Benefits
  "benefits.h2": "Tudo o que você precisa para entender o CSSBuy Spreadsheet",
  "benefits.findProducts": "Encontre Produtos",
  "benefits.findProductsDesc": "Descubra como pesquisar produtos e organizar informações relevantes.",
  "benefits.compareSellers": "Compare Vendedores",
  "benefits.compareSellersDesc": "Aprenda quais fatores analisar antes de escolher um vendedor.",
  "benefits.checkQC": "Confira o QC",
  "benefits.checkQCDesc": "Entenda como interpretar fotos de controle de qualidade.",
  "benefits.understandShipping": "Entenda o Envio",
  "benefits.understandShippingDesc": "Conheça os principais fatores que influenciam custos e métodos de envio.",

  // Spreadsheet Hub
  "spreadsheet.h2": "CSSBuy Spreadsheet",
  "spreadsheet.text": "Nossa central de CSSBuy Spreadsheet reúne recursos organizados por categoria para facilitar a pesquisa de produtos, vendedores e guias.",
  "spreadsheet.cta": "Explorar Spreadsheet",

  // Categories
  "categories.h2": "Categorias populares",
  "categories.viewAll": "Ver todas as categorias",
  "categories.shoes": "Tênis",
  "categories.hoodies": "Streetwear",
  "categories.tshirts": "Camisetas",
  "categories.sweaters": "Moletons",
  "categories.jackets": "Jaquetas",
  "categories.pants": "Calças",
  "categories.bags": "Bolsas",
  "categories.accessories": "Acessórios",
  "categories.sportswear": "Sportswear",

  // How It Works
  "howItWorks.h2": "Como usar um CSSBuy Spreadsheet?",
  "howItWorks.step1": "Pesquise",
  "howItWorks.step1Desc": "Encontre produtos, categorias ou vendedores.",
  "howItWorks.step2": "Analise",
  "howItWorks.step2Desc": "Confira informações e dados disponíveis.",
  "howItWorks.step3": "Compare",
  "howItWorks.step3Desc": "Avalie diferentes opções.",
  "howItWorks.step4": "Verifique",
  "howItWorks.step4Desc": "Confira QC, envio, armazenamento e segurança.",
  "howItWorks.step5": "Continue",
  "howItWorks.step5Desc": "Quando apropriado, siga para o site principal.",

  // Guides
  "guides.h2": "Guias para comprar com mais informação",
  "guides.viewAll": "Ver todos os guias",
  "guides.review": "CSSBuy Review",
  "guides.shipping": "CSSBuy Shipping Cost",
  "guides.warehouse": "CSSBuy Warehouse",
  "guides.legit": "CSSBuy Legit",
  "guides.coupon": "CSSBuy Coupon",
  "guides.discount": "CSSBuy Discount Code",

  // Comparison
  "comparison.h2": "Compare antes de escolher",
  "comparison.viewAll": "Ver comparações",

  // Safety
  "safety.h2": "Segurança vem primeiro",
  "safety.text": "Aprenda a verificar links, vendedores, produtos, QC, pagamentos e informações antes de comprar.",
  "safety.cta": "Abrir Central de Segurança",

  // Trust
  "trust.h2": "Conteúdo transparente e independente",
  "trust.text": "O CSSBuyBR.INK é um recurso independente criado para organizar informações, guias e recursos relacionados ao CSSBuy Spreadsheet. Não somos o site oficial do CSSBuy, salvo indicação expressa e verificável.",

  // Final CTA
  "finalCta.h2": "Pronto para explorar o CSSBuy Spreadsheet?",
  "finalCta.text": "Encontre recursos, compare informações e escolha o guia certo para sua próxima etapa.",
  "finalCta.primary": "Explorar CSSBuy Spreadsheet",
  "finalCta.secondary": "Visitar o site principal",

  // Category Dropdown
  "dropdown.title": "Categorias de Produtos",
  "dropdown.shoes": "Shoes",
  "dropdown.hoodies": "Hoodies/Sweaters",
  "dropdown.tshirts": "T-Shirts",
  "dropdown.jackets": "Jackets",
  "dropdown.pants": "Pants/Shorts",
  "dropdown.headwear": "Headwear",
  "dropdown.sets": "Sets",
  "dropdown.underwear": "Underwear/Underpants",
  "dropdown.jersey": "Jersey",
  "dropdown.accessories": "Accessories",
  "dropdown.bags": "Bags",
  "dropdown.belts": "Belts",
  "dropdown.perfumes": "Perfumes",
  "dropdown.other": "Other Stuff",

  // Buttons
  "button.cssbuySpreadsheet": "CSSBuy Spreadsheet",
  "button.buyItNow": "Buy It Now",

  // Footer
  "footer.about": "Sobre",
  "footer.editorial": "Política Editorial",
  "footer.contact": "Contato",
  "footer.privacy": "Privacidade",
  "footer.terms": "Termos",
  "footer.disclaimer": "Aviso Legal",
  "footer.disclaimerText": "CSSBuyBR.INK é um recurso independente de informações. Não somos o site oficial do CSSBuy. Sempre verifique informações importantes em fontes oficiais antes de comprar.",
  "footer.copyright": "© 2026 CSSBuyBR.INK — Recurso independente de CSSBuy Spreadsheet",

  // Articles
  "articles.h2": "Artigos e Guias",
  "articles.readMore": "Ler artigo completo",
  "articles.backToHome": "Voltar para página inicial",
  "articles.relatedArticles": "Artigos relacionados",
  "articles.updated": "Atualizado em",
  "articles.published": "Publicado em",
  "articles.author": "Autor",
  "articles.minRead": "min de leitura",
  "articles.keyTopics": "Principais tópicos",
  "articles.fullContentSoon": "O conteúdo completo deste guia está em preparação. Confira abaixo um resumo do que você vai encontrar.",

  // Language Switcher
  "lang.pt": "Português",
  "lang.en": "English",
  "lang.de": "Deutsch",

  // NotFound
  "notFound.title": "Página não encontrada",
  "notFound.description": "A página que você procura não existe ou foi movida.",
  "notFound.backHome": "Voltar para a página inicial",
};